import { SelectProps as AntdSelectProps } from 'antd';

export enum SelectWidth {
	Small = "Small",
	Default = "Default",
	Medium = "Medium",
	Large = "Large",
	XLarge = "XLarge",
	Full = "Full"
};

/**
 * all props
 */
export type SelectProps = AntdSelectProps & {
	options: { value: string, label: string }[];
	placeholder?: string;
	width?: SelectWidth;
};

/**
 * Define default props
 */
export type DefaultSelectProps = {
	options: NonNullable<(SelectProps['options'])>;
	placeholder: NonNullable<(SelectProps['placeholder'])>;
	width: SelectWidth;
};

/**
 * Default Value from default props
 */
export const defaultProps: DefaultSelectProps = {
	options: [],
	placeholder: "",
	width: SelectWidth.Full
};

export const selectWidthMap = {
	"Small": "5rem",
	"Default": "10rem",
	"Medium": "20rem",
	"Large": "30rem",
	"XLarge": "50rem",
	"Full": "100%"
};
